<template>
    <header class="w-full bg-zinc-900 text-zinc-50">
        <div class="mx-auto flex h-20 max-w-[1440px] items-center justify-between px-4 sm:px-8 lg:h-[120px] lg:px-24">
            <div>
                <!-- The business funnel carries the Privacy Bee Business lockup, which is a
                     published asset rather than the consumer logo. Sized by width,
                     as the portal's sidebar does: the mark carries a "business" descender, so
                     matching the logo's height would shrink the name above it. -->
                <img
                    v-if="business"
                    src="/img/logo/privacy-bee-business.png"
                    alt="Privacy Bee Business"
                    width="176"
                    height="36"
                    class="h-9 w-44"
                >
                <PbLogo v-else aria-label="Privacy Bee" :width="183" :height="36" />
            </div>
            <!-- The right-hand line: the funnel's trust copy unless the page has something of
                 its own to say there (the proposal page names the document and its sender). -->
            <div class="hidden items-center gap-3 text-sm font-medium leading-5 md:flex">
                <slot>
                    <PhMedal :size="20" weight="fill" class="text-amber-400" />
                    <span>Trusted by millions</span>
                    <span class="text-zinc-500" aria-hidden="true">•</span>
                    <span>Quick and hassle-free checkout</span>
                </slot>
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import { PhMedal } from '@phosphor-icons/vue';
import PbLogo from '@privacy-bee/design-system/vue/PbLogo.vue';

/** The business funnel brands itself; every other step of the checkout is Privacy Bee. */
withDefaults(defineProps<{ business?: boolean }>(), { business: false });
</script>
